/* eslint-disable */
import * as Types from '../../../../../../generated/graphql'

import { gql } from '@apollo/client'
export type GQLDatingFragment = {
  __typename?: 'PublicProfile'
  dating: {
    __typename?: 'PublicDatingProfile'
    aboutMe: string
    lookFor: Array<Types.GQLLookFor>
    datingGoals?: Array<Types.GQLDatingGoals> | null
    knownLanguages?: Array<any> | null
    height?: number | null
    weight?: number | null
    orientation?: Types.GQLOrientation | null
    children?: Types.GQLChildren | null
    education?: Types.GQLEducation | null
    appearance?: Types.GQLAppearance | null
    constitution?: Types.GQLConstitution | null
    alcohol?: Types.GQLAlcoholAttitude | null
    smoking?: Types.GQLSmokingAttitude | null
    homeStatus?: Types.GQLHomeStatus | null
    materialStatus?: Types.GQLMaterialStatus | null
    lookForAge: { __typename?: 'AgeRange'; from: number; to: number }
  }
  sharing?: {
    __typename?: 'PublicSharing'
    widgets?: {
      __typename?: 'PublicWidgets'
      thisIsMe?: { __typename?: 'ThisIsMeWidget'; url: string } | null
    } | null
  } | null
}

export const DatingFragmentDoc = gql`
  fragment Dating on PublicProfile {
    dating {
      aboutMe
      lookForAge {
        from
        to
      }
      lookFor
      datingGoals
      knownLanguages
      height
      weight
      orientation
      children
      education
      appearance
      constitution
      alcohol
      smoking
      homeStatus
      materialStatus
    }
    sharing @skip(if: $authorized) {
      widgets {
        thisIsMe {
          url
        }
      }
    }
  }
`
